import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  role: "list",
  class: "grid grid-cols-2 gap-6 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3"
}
const _hoisted_2 = { class: "flex items-center justify-center min-h-screen p-4" }
const _hoisted_3 = { class: "relative max-w-md mx-auto bg-gray-lightShow rounded-md" }
const _hoisted_4 = { class: "p-4 space-y-8" }
const _hoisted_5 = { class: "font-bold text-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-2xl text-black font-bold text-center" }, " SNS審査が必要です ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-base" }, " SHOWで取り上げている特別優待は、インフルエンサーの方に限定公開することを前提としているため、SNS審査をさせて頂きます。 ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-black font-bold" }, " 審査には2〜3営業日いただくことがございます。審査に関してご不明な点がございましたら、LINEでお問い合わせください。 ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogOverlay = _resolveComponent("DialogOverlay")!
  const _component_TransitionChild = _resolveComponent("TransitionChild")!
  const _component_DialogTitle = _resolveComponent("DialogTitle")!
  const _component_DialogDescription = _resolveComponent("DialogDescription")!
  const _component_SProfileSnsCell = _resolveComponent("SProfileSnsCell")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_TransitionRoot = _resolveComponent("TransitionRoot")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TransitionRoot, {
      show: _ctx.isOpen,
      as: "template"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Dialog, { class: "fixed inset-0 z-10 overflow-y-auto" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_TransitionChild, {
                as: "template",
                enter: "duration-300 ease-out",
                "enter-from": "opacity-0",
                leave: "duration-200 ease-in",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DialogOverlay, { class: "fixed inset-0 bg-gray-800 opacity-60" })
                ]),
                _: 1
              }),
              _createVNode(_component_TransitionChild, {
                as: "template",
                enter: "duration-300 ease-out",
                "enter-from": "opacity-0 scale-0",
                "enter-to": "opacity-100 scale-100",
                leave: "duration-200 ease-in",
                "leave-from": "opacity-100 scale-100",
                "leave-to": "opacity-0 scale-0"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.nickName) + " 様", 1),
                      _createVNode(_component_DialogTitle, null, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_DialogDescription, null, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_SProfileSnsCell),
                      _hoisted_8
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}